<template>
  <div class="passwordetail">
    <div class="passwordetail_title">
      <p>消息</p>
    </div>

  </div>
</template>

<script>
export default {
  name: "mynotice"
}
</script>

<style scoped>

</style>